import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as lightspeedActions from './lightspeedActions';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import { Button } from 'merchant-portal-components';
import { LoadingBlueLarge } from 'merchant-portal-components';
import { Box } from '@material-ui/core';
const LinkLightspeedContainer = ({
  getLightspeedStatus,
  getLightspeedLink,
  isLightspeedConnected,
  isRequesting,
}) => {
  useEffect(() => {
    getLightspeedStatus();
    track.page('app-settings-tags');
    return () => {};
  }, []);

  const handleLinkLightspeed = async () => {
    getLightspeedLink();
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr' }}>
        <BreadCrumb pageName='Link Lightspeed Account' />
      </div>
      <div
        style={{
          backgroundColor: '#fff',
          padding: '20px',
          marginTop: '20px',
          borderRadius: '15px',
          minHeight: '400px',
        }}
      >
        {isRequesting ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <LoadingBlueLarge />
          </Box>
        ) : (
          <Button variant='primary' onClick={handleLinkLightspeed}>
            {isLightspeedConnected
              ? 'Re-Connect to Lightspeed Account'
              : 'Connect to Lightspeed Account'}
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLightspeedConnected: state.lightspeedReducer.isLightspeedConnected,
    isRequesting: state.lightspeedReducer.isRequesting,
  };
};

export default connect(
  mapStateToProps,
  lightspeedActions
)(LinkLightspeedContainer);
